import React from "react";

import { LAYOUTS_NO_ITEMS_STRINGS, NO_ITEMS_STRINGS } from "constants/constantStrings";

import "./index.scss";

const NoItemsLayout = ({ currentLayout, page }) => (
  <div className="no-data-view">
    <label className="dupont-form-label">{currentLayout ? NO_ITEMS_STRINGS.NoDataTitle : NO_ITEMS_STRINGS.NoLayoutAvailable}</label>
    <ul>
      <li className="descriptionText">
        <div className="no-data-view__item">
          {NO_ITEMS_STRINGS.NoDataOption1}
          <span className="expand-icon no-data-view--icon" />
        </div>
      </li>

      {currentLayout && (
        <li className="descriptionText">
          <div className="no-data-view__item">{NO_ITEMS_STRINGS.NoDataOption2.replace("[%]", currentLayout)}</div>
        </li>
      )}
      <li className="descriptionText">
        <div className="no-data-view__item">
          {currentLayout ? NO_ITEMS_STRINGS.NoDataOption3_1 : LAYOUTS_NO_ITEMS_STRINGS.noLayoutsOption1}
          <span className={currentLayout ? `add-widget-icon no-data-view--icon` : "add-layout-icon"} />
          {currentLayout ? NO_ITEMS_STRINGS.NoDataOption3_2.replace("[%]", page) : ""}
        </div>
      </li>
      <li className="descriptionText">
        <div className="no-data-view__item">{currentLayout ? NO_ITEMS_STRINGS.NoDataOption4 : LAYOUTS_NO_ITEMS_STRINGS.noLayoutsOption2} </div>
      </li>
    </ul>
  </div>
);

export default NoItemsLayout;
